import { useField } from 'formik';
import * as React from 'react';
import { single } from '../../../lib/utils';

const HiddenField = (props: Props) => {
	const fieldName = single(props.fieldNames);
	const [, , helpers] = useField(fieldName);

	React.useEffect(() => {
		helpers.setValue(props.value);
	}, []);

	return <></>;
};

interface Props {
	fieldNames: string[];
	value: string;
}

export default HiddenField;
